import type { AgentAvailability } from '@/types';
import type { LabelKey } from '@/i18n/labels';

/**
 * The design surfaces three availability choices (Available / Busy / Away).
 * The backend `AgentAvailability` enum is ONLINE / BUSY / OFFLINE — so "Away"
 * maps onto OFFLINE (there is no distinct connected-but-away state on the hub).
 */
export const AVAIL_OPTIONS: AgentAvailability[] = ['ONLINE', 'BUSY', 'OFFLINE'];

/** CSS status-dot class (see agent-console.css .ac-status-dot.*). */
export function availDotClass(a: AgentAvailability): string {
  switch (a) {
    case 'ONLINE':
      return 'online';
    case 'BUSY':
      return 'busy';
    default:
      return 'away'; // OFFLINE presented as "Away" per the design's 3-state set
  }
}

/** i18n label key for an availability value (design vocabulary). */
export function availLabelKey(a: AgentAvailability): LabelKey {
  switch (a) {
    case 'ONLINE':
      return 'available';
    case 'BUSY':
      return 'busy';
    default:
      return 'away';
  }
}
